import React, { useState, useEffect, useContext, useRef } from 'react'
import Card from '../../../../Components/Card/Card'
import CalendarioOperativo from '../../../../Components/CalendarioOperativo/CalendarioOperativo'
import AgGrid from '../../../../Components/Tables/AgGrid/AgGrid'
import ModalCuentasPorPagarCompras from '../ModalCXP/ModalCuentasPorPagarCompras'
import { AuthContext } from '../../../../Context/AuthContext/AuthContext'
import { ConfigContext } from '../../../../Context/ConfigContext/ConfigContext'
import { getFechasCuentasPorPagarDetalles, getFechasDetallesCompras, getFechasDetallesMateriaPrima, getFechasFacturasMateriaPrima } from '../../../../API/CuentasPorPagar/CXP/CuentasPorPagarRequest'
import { Button } from 'primereact/button'
import Loader from '../../../../Components/Loader/Loader'
import { getDateProduction } from '../../../../Services/FechasService'
import { CuentasPorPagarLang } from '../Lang/CuentasPorPagarLang'
import { getLabel } from '../../../../Services/Language/LanguageService'
import CalendarioMensual from '../../../../Components/CalendarioMensual/CalendarioMensual'

const DetallesRegistroFacturas = ({isMateriaPrima = false}) => {

    const [loading, setLoading] = useState(false);
    const [dates, setDates] = useState([new Date(), new Date()])
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState([]);
    const [dialogCuentas, setDialogCuentas] = useState(false);
    const [IdFactura, setIdFactura] = useState(0);

    const { userAuth } = useContext(AuthContext);
    const { config } = useContext(ConfigContext);


    const obtenerInformacion = async () => {
        setLoading(true)
        // const result = await getFechasCuentasPorPagarDetalles(getDateProduction(dates))
        let result = []
        if(!isMateriaPrima){
            result = await getFechasDetallesCompras(getDateProduction(dates))
        }else{
            result = await getFechasDetallesMateriaPrima(getDateProduction(dates))
        }
        setData(result)
        setSelected([])
        setLoading(false)
    }

    const OpenModal = (rowData) => {
        if (rowData) {
            setIdFactura(rowData?.IdEncabezado)
        }
        setDialogCuentas(true)
    }

    const hideDialog = () => {
        setIdFactura(null)
        setDialogCuentas(false)
        obtenerInformacion()
    }


    const table = {
        Data: data,
        selected: selected,
        setSelected: setSelected,
        Columns: [
            {
                field: 'IdDetalle',
                header: 'IdDetalle',
                headerEn: 'IdDetalle',
                className: 'XXsmall',
                hidden: userAuth.IdRol === 1,
                Frozen: true,
                alignFrozen: 'left'
            },
            {
                field: 'NoIngreso',
                header: 'No Ingreso',
                headerEn: 'Income Number',
                className: 'Xsmall',
                onCellDoubleClicked: ({ data }) => {
                    if (data?.IdEncabezado) {
                        OpenModal(data)
                    }
                },
                sort: 'desc',
                Format: 'Center',
                Sumary: 'count',
                Frozen: true,
                alignFrozen: 'left'
            },

            {
                field: 'FechaEmision',
                header: 'Fecha Factura',
                headerEn: 'Invoice Date',
                className: 'Xsmall',
                Frozen: true,
                alignFrozen: 'left'
            },

            {
                field: 'Documento',
                header: 'Factura',
                headerEn: 'Invoice',
                className: 'medium',
                Frozen: true,
                alignFrozen: 'left'
            },
            {
                field: 'Proveedor',
                header: 'Proveedor',
                headerEn: 'Supplier',
                className: 'XXlarge',
            },
            {
                field: 'CodigoProducto',
                header: 'Codigo Producto',
                headerEn: 'Producto Code',
                className: 'medium',
                Format:'Center'
            },
            {
                field: 'NombreProducto',
                header: 'Producto',
                headerEn: 'Product',
                className: 'XXXXlarge',
            },
            {
                field: 'FechaIngreso',
                header: 'Fecha Ingreso',
                headerEn: 'Income Date',
                className: 'small',
                Format: 'Date',
            },

            {
                field: 'PurchaseOrder',
                header: 'PO',
                headerEn: 'Purchase Order',
                className: 'Xsmall',
            },
            {
                field: 'Currency',
                header: 'Moneda',
                headerEn: 'Moneda',
                className: 'Xsmall',
                Formart: 'center'
            },

            {
                field: 'NombreReferencia',
                header: 'Tipo Factura',
                headerEn: 'Invoice Type',
                className: 'small',
            },
            {
                field: 'MemoDet',
                header: 'Descripción ',
                headerEn: 'Description',
                className: 'XXlarge',
            },
            {
                field: 'ComentarioRegistro',
                header: 'Comentario Registro',
                headerEn: 'Comment',
                className: 'XXlarge',
            },

            {
                headerName: 'Lempiras',
                children: [
                    {
                        field: 'PrecioLiquidacionL',
                        header: 'Precio UL',
                        headerEn: 'Price UL',
                        className: 'Xsmall',
                        Format: 'Currency',
                        hidden: userAuth.IdRol === 1
                    },
                    {
                        field: 'CostoL',
                        header: 'Costo L',
                        headerEn: 'Cost L',
                        className: 'Xsmall',
                        Format: 'Currency',
                        Sumary: 'sum',
                        // Frozen: true,
                        // alignFrozen: 'right',
                        hidden: userAuth.IdRol === 1
                    },
                ]
            },
            {
                headerName: 'Dolares',
                children: [
                    {
                        field: 'PrecioLiquidacionD',
                        header: 'Precio UD',
                        headerEn: 'Price UD',
                        className: 'Xsmall',
                        Format: 'Currency',
                        hidden: userAuth.IdRol === 1
                    },

                    {
                        field: 'CostoD',
                        header: 'Costo $',
                        headerEn: 'Cost D',
                        className: 'Xsmall',
                        Format: 'Currency',
                        Sumary: 'sum',

                        hidden: userAuth.IdRol === 1
                    },
                ]
            },
            {
                field: 'IsExento',
                header: 'IsExento',
                className: 'Xsmall',
                Format: 'Checkbox',
                width:80,
                Frozen: true,
                alignFrozen: 'right',
                onChange: (e, rowData) => { }
            },

            {
                headerName: 'Lempiras',
                children: [
                    {
                        field: 'PrecioL',
                        header: 'Precio L',
                        headerEn: 'Price L',
                        className: 'Xsmall',
                        Format: 'Currency',
                        Frozen: true,
                        alignFrozen: 'right',

                    },
                    {
                        field: 'MontoL',
                        header: 'Monto L',
                        headerEn: 'Amount L',
                        className: 'Xsmall',
                        Format: 'Currency',
                        Sumary: 'sum',
                        Frozen: true,
                        alignFrozen: 'right',

                    },
                ]

            },
            {
                headerName: 'Dolares',
                children: [
                    {
                        field: 'PrecioD',
                        header: 'Precio D',
                        headerEn: 'Price D',
                        className: 'Xsmall',
                        Format: 'Currency',
                        Frozen: true,
                        alignFrozen: 'right',
                    },
                    {
                        field: 'MontoD',
                        header: 'Monto $',
                        headerEn: 'Amount D',
                        className: 'Xsmall',
                        Format: 'Currency',
                        Sumary: 'sum',
                        frozen: true,
                        alignFrozen: 'right',

                    },
                ]
            },


        ]
    }

    return (
        <div>
            <Loader loading={loading} querySelector='#CXPDetalles' />
            <Card
                titulo={<div className='d-flex flex-row'>
                    <CalendarioMensual
                        getInfo={ !isMateriaPrima ? getFechasDetallesCompras : getFechasDetallesMateriaPrima}
                        data={data}
                        setData={setData}
                        dates={dates}
                        setDates={setDates}
                        selected={selected}
                        setSelected={setSelected}
                        loading={loading}
                        setLoading={setLoading}
                    />

                    <Button icon='pi pi-plus' onClick={() => OpenModal(null)} className='mx-2' style={{ height: 35, marginTop: 2 }} tooltip={getLabel(CuentasPorPagarLang, 'tooltipNuevo', config?.language)} />
                </div>}

                contenido={<div className='pt-4' style={{ height: '85vh' }} id='CXPDetalles'>
                    <AgGrid table={table} />
                </div>}
            />

            <ModalCuentasPorPagarCompras
                dialogCuentas={dialogCuentas}
                hideDialog={hideDialog}
                IdFactura={IdFactura}
            />
        </div>
    )
}

export default DetallesRegistroFacturas